import { Middleware } from "@nuxt/types"
import { getInvalidSubscriptionRoute } from '~/middleware/canAccessMemberApp'
import { isSitecoreRequest } from "~/utils/isSitecoreRequest"

const allowNonMember: Middleware = ({ req, app, store, redirect, query, error }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  const { nonMemberAccount } = store.getters.currentUser.membership

  if (nonMemberAccount) {
    return
  }

  const subscriptionRoute = getInvalidSubscriptionRoute(store.getters.currentUser, error)

  if (subscriptionRoute) {
    return redirect(app.localePath({ name: subscriptionRoute, query }))
  }
}

export default allowNonMember
